import { datadogRum } from '@datadog/browser-rum';
import { clientEnvVars } from './common/environment/clientEnvVars';

const isProduction = clientEnvVars().NODE_ENV === 'production';

if (isProduction) {
  datadogRum.init({
    applicationId: '4c7f5812-60eb-4d18-bfe3-6ddf71e86dfb',
    clientToken: 'pubf244f60f161d6f80ef357991c8633523',
    site: 'datadoghq.com',
    service: 'nora-fe',
    env: 'production',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 10,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: true,
  });
}
